'use client';

import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { BoxButton, Drawer, DrawerBody, DrawerContent, DrawerFooter, List, ModalStickyBottomWrapper } from '@repo/ui';

import { SnsType } from '@/lib/types/auth';

export const LogoutDialog = NiceModal.create(({ email, loginType }: { email: string; loginType: SnsType }) => {
  const modal = useModal();

  const handleClose = () => {
    modal.resolve(false);
    modal.hide();
  };

  const handleConfirmLogout = () => {
    modal.resolve(true);
    modal.hide();
  };

  return (
    <Drawer open={modal.visible}>
      <DrawerContent outSideClickAction={handleClose}>
        <DrawerBody className={'px-normal-large'}>
          <div className={'flex flex-col gap-normal-small'}>
            <div className={'heading-small-bold pt-normal-large pb-normal-small'}>아래 계정을 로그아웃할까요?</div>

            <p className={'body-medium-medium text-gray-800'}>
              로그아웃해도 환급에 필요한 정보는
              <br />
              알림톡으로 계속 받아보실 수 있어요.
            </p>

            <div className={'rounded-bzc-medium bg-gray-50 px-5 pb-2 pt-5'}>
              <p className={'caption-small-regular text-gray-800'}>
                지금 계정의 환급 정보를 확인하려면
                <br />
                나중에 다시 이 계정으로 로그인해주세요
              </p>

              <List title={email} overline={'이메일 주소'} />
              <List title={snsTypeToLoginType(loginType)} overline={'현재 로그인 방법'} />
            </div>
          </div>
        </DrawerBody>

        <DrawerFooter>
          <ModalStickyBottomWrapper>
            <div className={'flex w-full gap-4'}>
              <BoxButton size={'large'} variant={'tonal-secondary'} onClick={handleClose} className="w-full">
                아니요
              </BoxButton>
              <BoxButton size={'large'} variant={'filled-primary'} onClick={handleConfirmLogout} className="w-full">
                네
              </BoxButton>
            </div>
          </ModalStickyBottomWrapper>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
});

function snsTypeToLoginType(type: SnsType) {
  switch (type) {
    case 'APPLE':
      return '애플';
    case 'NAVER':
      return '네이버';
    case 'KAKAO':
      return '카카오톡';
    default:
      return '이메일';
  }
}
